import { courseVersionsInitState } from './DirectAccessInitState';
import { IAction } from '../../../__core/Interfaces/IAction';
import DIRECT_ACCESS_ACTIONS from '../Actions/ActionTypes';
import { CourseVersionsResponse } from '../Types/CourseVersionsResponse';

export const courseVersionsReducer = (
  state: CourseVersionsResponse = courseVersionsInitState,
  action: IAction<CourseVersionsResponse>
): CourseVersionsResponse => {
  switch (action.type) {
    case DIRECT_ACCESS_ACTIONS.DIRECT_ACCESS_FETCH_COURSE_VERSIONS:
      return { ...action.payload };

    default:
      return state;
  }
};
